import { servicesApi } from '@/services/api/deprecated';

export type ZendeskChatToken = {
  token: string;
};

export type ZendeskChatAccess = ZendeskChatToken & {
  is_handover_allowed: boolean;
  token_lifetime_minutes: number;
};

export const getZendeskChatAccess = async (accountId: number | undefined, userId: number | undefined) => {
  const { data } = await servicesApi.get<ZendeskChatAccess>(`/accounts/${accountId}/users/${userId}/zendesk_chat`);
  return data;
};

export const postZendeskChatToken = async (accountId: number | undefined, userId: number | undefined) => {
  const { data } = await servicesApi.post<ZendeskChatToken>(
    `/accounts/${accountId}/users/${userId}/zendesk_chat/token`,
  );
  return data;
};
